import MuiDialogActions from '@mui/material/DialogActions'

const styles = {
  margin: 0
  // padding: theme.spacing(1)
}

export default function DialogActions(props: Record<string, any>): JSX.Element {
  return <MuiDialogActions sx={styles} {...props} />
}
